<div *ngIf="!dataLoaded" class="loader" [ngClass]="{
    'project-level': pageType === 'projectLevel' || pageType === 'vendorLevel'
  }">
  <app-loading></app-loading>
</div>

<div *ngIf="dataLoaded">
  <mat-tab-group *ngIf="!matrixOverView" mat-align-tabs="start" (selectedTabChange)="changeTab($event)" [selectedIndex]="activeTab">
    <mat-tab label="Balanced Scorecard">
      <div class="d-flex justify-content-end gap-4 align-items-center mt-1" *ngIf="!iframeEmbedded">
        <mat-form-field *ngIf="searchEnabled" appearance="outline" floatLabel="always" class="search-field">
          <mat-label>Search Metric</mat-label>
          <input matInput #searchMetricsInput [(ngModel)]="metricSearchTerm" (ngModelChange)="onMetricSearch()"
            placeholder="Enter metric name..." (keydown.escape)="clearSearchHighlight()"
            (keydown.enter)="goToNextSearchResult()" />
          <button mat-icon-button matSuffix type="button" aria-label="Clear highlights"
            (keydown.escape)="clearSearchHighlight()" (click)="clearSearchHighlight()" [disabled]="!hasActiveHighlight"
            title="Clear">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <div class="d-flex">
          <button *ngIf="searchEnabled" mat-icon-button type="button" aria-label="Previous match"
            (click)="goToPrevSearchResult()" [disabled]="
              !metricSearchResults || metricSearchResults.length === 0
            " title="Previous">
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button *ngIf="searchEnabled" mat-icon-button type="button" aria-label="Next match"
            (click)="goToNextSearchResult()" [disabled]="
              !metricSearchResults || metricSearchResults.length === 0
            " title="Next">
            <mat-icon>arrow_downward</mat-icon>
          </button>
        </div>
        <mat-icon [matTooltip]="searchEnabled ? 'Disable Search' : 'Enable Search'" matSuffix
          (click)="onSearchEnableClicked()">search</mat-icon>
        <button *ngIf="pageType === 'projectLevel'" mat-flat-button mat-button color="primary"
          class="bg-primary text-white" [disabled]="showRecommendedWidgets" (click)="showAddMetricDialog(true)">
          <mat-icon>add</mat-icon> Metric
        </button>
        <!-- <mat-icon
          matTooltip="Download PDF"
          (click)="downloadPDF(tooltip)"
          #tooltip="matTooltip"
          >cloud_download</mat-icon
        > -->
      </div>
      <div class="quadrantsContainer hide-scroll-bar mt-2" id="cardsContainer">
        <div class="row mb-4 align-items-center hidden" id="bscHeader">
          <p *ngIf="pageType === 'projectLevel'" class="col-10 header-info">
            Balanced scorecard
          </p>
          <p *ngIf="pageType !== 'projectLevel'" class="col-10 header-info">
            Balanced scorecard for {{ headerInfo }}
          </p>
          <p class="col-2 date">{{ currentDate | appFormat : "date" }}</p>
        </div>
        <div style="overflow: hidden">
          <div class="row">
            <div class="bsc-card-container col-md-12 col-lg-12 col-xxl-6 mb-4">
              <div class="column-bg-1 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="fas fa-user-friends user-icon"> </i>
                  <p class="title ms-2">{{ quadrants?.customer }}</p>
                  <span (click)="showPulses('customer', 1)" *ngIf="pulseCounts?.Customer?.positive_pulses > 0"
                    class="positive-pulse mb-3 ms-1">
                  </span>
                  <span (click)="showPulses('customer', 2)" *ngIf="pulseCounts?.Customer?.negative_pulses > 0"
                    class="negative-pulse mb-3 ms-1">
                  </span>
                  <ng-container *ngTemplateOutlet="
                      statusCounts;
                      context: { quadrantId: customerId }
                    "></ng-container>
                </div>
                <div class="pe-2">
                  <mat-icon (click)="quadrantInfo(140, info, 'Customer')" matTooltip="Customer Quadrant">info</mat-icon>
                </div>
              </div>
              <div *ngIf="!noDataCustomer">
                <!--Customer Card start-->
                <div class="table-responsive bsc-card" style="height: 310px">
                  <table id="table-sparkline" class="table" style="font-size: 0.5rem; border-top: medium none">
                    <ng-container *ngTemplateOutlet="matricTableBody"></ng-container>
                    <tbody id="tbody-sparkline" class="example-list" cdkDropListGroup cdkDropList
                      [cdkDropListData]="customerDisplayData" (cdkDropListDropped)="drop($event, 140)">
                      <tr id="metric-{{ metric?.id }}" title="click to drag and drop"
                        *ngFor="let metric of customerDisplayData; index as i" cdkDrag
                        class="example-box scorecard-metric"
                        (click)="enableDragClick(i, 140)" [cdkDragDisabled]="
                          dragCustomerEnableFlag[i]
                            ? dragCustomerEnableFlag[i]
                            : true
                        ">
                        <td (click)="
                            clickOverView(
                              140,
                              metric,
                              customerDisplayData,
                              'Customer'
                            )
                          " class="text-primary cursor-pointer" style="width: 37%">
                          <span class="fw-bold text-underline" matTooltip="{{ metric?.desc }}"
                            matTooltipClass="example-tooltip">{{ metric?.name }}&nbsp;
                            <span *ngIf="metric?.unit_name">({{ metric?.unit_name }})</span></span>
                        </td>
                        <td>
                          <div *ngIf="hasTrend(metric?.balanceTrend)" [chart]="metric?.balanceTrend"></div>
                          <div *ngIf="!hasTrend(metric?.balanceTrend)" class="no-data">
                            {{ commonText.no_trend_to_display }}
                          </div>
                        </td>
                        <td>
                          <span class="fw-bold" [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">{{
                            getFormattedValue(metric?.actual_value)
                            }}</span>
                        </td>
                        <td class="text-center" *ngIf="metric.change != 'false'">
                          <div class="fw-bold" [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">
                            {{ getFormattedValue(metric?.change) }}
                          </div>
                          <span class="px-2 d-block">{{
                            metric?.variance_per | appFormat : "float"
                            }}%</span>
                        </td>
                        <td *ngIf="metric.change == 'false'"></td>
                        <ng-container *ngTemplateOutlet="
                            actionCell;
                            context: { metric: metric }
                          "></ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--Customer Card end-->
              </div>
              <div class="row" *ngIf="noDataCustomer">
                <div class="col-md-8 mx-auto mt-5" style="height: 200px">
                  <p class="text-center text-muted mt-2 fw-bold mb-1">
                    {{ commonText.no_records_found }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bsc-card-container col-md-12 col-lg-12 col-xxl-6 mb-4">
              <div class="column-2-bg d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="fas fa-sack-dollar user-icon"> </i>
                  <p class="title ms-2">{{ quadrants?.finance }}</p>
                  <span (click)="showPulses('finance', 1)" *ngIf="pulseCounts?.Finance?.positive_pulses > 0"
                    class="positive-pulse mb-3 ms-1">
                  </span>
                  <span (click)="showPulses('finance', 2)" *ngIf="pulseCounts?.Finance?.negative_pulses > 0"
                    class="negative-pulse mb-3 ms-1">
                  </span>
                  <ng-container *ngTemplateOutlet="
                      statusCounts;
                      context: { quadrantId: financeId }
                    "></ng-container>
                </div>
                <div class="pe-2">
                  <img src="./assets/images/budget_map.svg" style="
                      margin-right: 2px;
                      vertical-align: top;
                      cursor: pointer;
                    " *ngIf="showFinanceComparitor" (click)="openBugetMap()" matTooltip="Budget Map" />
                  <mat-icon *ngIf="showFinanceComparitor" (click)="openFinanceComparitor()"
                    matTooltip="Comparator">bar_chart</mat-icon>

                  <mat-icon (click)="quadrantInfo(138, info, 'Finance')" matTooltip="Finance Quadrant">info</mat-icon>
                </div>
              </div>
              <div *ngIf="!noDataFinance">
                <!--finance Card start-->
                <div class="table-responsive bsc-card" style="height: 310px">
                  <table id="table-sparkline" class="table" style="font-size: 0.5rem; border-top: medium none">
                    <ng-container *ngTemplateOutlet="matricTableBody"></ng-container>
                    <tbody id="tbody-sparkline" class="example-list" cdkDropListGroup cdkDropList
                      [cdkDropListData]="financeDisplayData" (cdkDropListDropped)="drop($event, 138)">
                      <tr id="metric-{{ metric?.id }}" title="click to drag and drop"
                        *ngFor="let metric of financeDisplayData; index as i" cdkDrag
                        class="example-box scorecard-metric"
                        (click)="enableDragClick(i, 138)" [cdkDragDisabled]="
                          dragFinanceEnableFlag[i]
                            ? dragFinanceEnableFlag[i]
                            : true
                        ">
                        <td (click)="
                            clickOverView(
                              138,
                              metric,
                              financeDisplayData,
                              'Finance'
                            )
                          " class="text-primary cursor-pointer" style="width: 37%">
                          <span class="fw-bold text-underline" matTooltip="{{ metric?.desc }}"
                            matTooltipClass="example-tooltip">{{ metric?.name }}&nbsp;
                            <span *ngIf="metric?.unit_name">({{ metric?.unit_name }})</span></span>
                        </td>
                        <td>
                          <div *ngIf="hasTrend(metric?.balanceTrend)" [chart]="metric?.balanceTrend"></div>
                          <div *ngIf="!hasTrend(metric?.balanceTrend)" class="no-data">
                            {{ commonText.no_trend_to_display }}
                          </div>
                        </td>
                        <td>
                          <span class="fw-bold" [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">{{
                            getFormattedValue(metric?.actual_value)
                            }}</span>
                        </td>
                        <td class="text-center">
                          <div class="fw-bold" [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">
                            {{ getFormattedValue(metric?.change) }}
                          </div>
                          <span class="px-2 d-block">{{
                            metric?.variance_per | appFormat : "float"
                            }}%</span>
                        </td>
                        <ng-container *ngTemplateOutlet="
                            actionCell;
                            context: { metric: metric }
                          "></ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--finance Card end-->
              </div>
              <div class="row" *ngIf="noDataFinance">
                <div class="col-md-8 mx-auto mt-5" style="height: 200px">
                  <p class="text-center text-muted mt-2 fw-bold mb-1">
                    {{ commonText.no_records_found }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bsc-card-container col-md-12 col-lg-12 col-xxl-6 mb-4">
              <div class="column-bg-3 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="fas fa-users user-icon"> </i>
                  <p class="title ms-2">{{ quadrants?.engineering }}</p>
                  <span (click)="showPulses('delivery', 1)" *ngIf="pulseCounts?.Delivery?.positive_pulses > 0"
                    class="positive-pulse mb-3 ms-1">
                  </span>
                  <span (click)="showPulses('delivery', 2)" *ngIf="pulseCounts?.Delivery?.negative_pulses > 0"
                    class="negative-pulse mb-3 ms-1">
                  </span>
                  <ng-container *ngTemplateOutlet="
                      statusCounts;
                      context: { quadrantId: enggId }
                    "></ng-container>
                </div>
                <div class="pe-2">
                  <!-- <mat-icon
                    *ngIf="showFinanceComparitor"
                    (click)="openTechMap()"
                    matTooltip="Tech Map"
                    >map</mat-icon
                  > -->
                  <mat-icon (click)="quadrantInfo(139, info, 'Delivery')" matTooltip="Delivery Quadrant">info</mat-icon>
                </div>
              </div>
              <div *ngIf="!noDataDelivery">
                <!--engg Card start-->
                <div class="table-responsive bsc-card" style="height: 310px">
                  <table id="table-sparkline" class="table" style="font-size: 0.5rem; border-top: medium none">
                    <ng-container *ngTemplateOutlet="matricTableBody"></ng-container>
                    <tbody id="tbody-sparkline" class="example-list" cdkDropListGroup cdkDropList
                      [cdkDropListData]="engineerDisplayData" (cdkDropListDropped)="drop($event, 139)">
                      <tr id="metric-{{ metric?.id }}" title="click to drag and drop"
                        *ngFor="let metric of engineerDisplayData; index as i" cdkDrag
                        class="example-box scorecard-metric"
                        (click)="enableDragClick(i, 139)" [cdkDragDisabled]="
                          dragEnggEnableFlag[i] ? dragEnggEnableFlag[i] : true
                        ">
                        <td (click)="
                            clickOverView(
                              139,
                              metric,
                              engineerDisplayData,
                              'Engineering'
                            )
                          " class="text-primary cursor-pointer" style="width: 37%">
                          <span class="fw-bold text-underline" matTooltip="{{ metric?.desc }}"
                            matTooltipClass="example-tooltip">{{ metric?.name }}&nbsp;
                            <span *ngIf="metric?.unit_name">({{ metric?.unit_name }})</span></span>
                        </td>
                        <td>
                          <div *ngIf="hasTrend(metric?.balanceTrend)" [chart]="metric?.balanceTrend"></div>
                          <div *ngIf="!hasTrend(metric?.balanceTrend)" class="no-data">
                            {{ commonText.no_trend_to_display }}
                          </div>
                        </td>
                        <td>
                          <span class="fw-bold" [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">{{
                            getFormattedValue(metric?.actual_value)
                            }}</span>
                        </td>
                        <td class="text-center">
                          <div class="fw-bold" [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">
                            {{ getFormattedValue(metric?.change) }}
                          </div>
                          <span class="px-2 d-block">{{
                            metric.variance_per | appFormat : "float"
                            }}%</span>
                        </td>
                        <ng-container *ngTemplateOutlet="
                            actionCell;
                            context: { metric: metric }
                          "></ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--engg Card end-->
              </div>
              <div class="row" *ngIf="noDataDelivery">
                <div class="col-md-8 mx-auto mt-5" style="height: 200px">
                  <p class="text-center text-muted mt-2 fw-bold mb-1">
                    {{ commonText.no_records_found }}
                  </p>
                </div>
              </div>
            </div>
            <div class="bsc-card-container col-md-12 col-lg-12 col-xxl-6 mb-4">
              <div class="column-bg-4 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="fas fa-chart-bar user-icon"></i>
                  <p class="title ms-2">{{ quadrants?.people }}</p>
                  <span (click)="showPulses('people', 1)" *ngIf="pulseCounts?.People?.positive_pulses > 0"
                    class="positive-pulse mb-3 ms-1">
                  </span>
                  <span (click)="showPulses('people', 2)" *ngIf="pulseCounts?.People?.negative_pulses > 0"
                    class="negative-pulse mb-3 ms-1">
                  </span>
                  <ng-container *ngTemplateOutlet="
                      statusCounts;
                      context: { quadrantId: peopleId }
                    "></ng-container>
                </div>

                <div class="pe-2">
                  <mat-icon (click)="showPeopleInsights()" matTooltip="People Insights"
                    *ngIf="showPeopleInsightsButton === 'true'">show_chart</mat-icon>
                  <mat-icon (click)="quadrantInfo(137, info, 'People')" matTooltip="People Quadrant">info</mat-icon>
                </div>
              </div>
              <div *ngIf="!noDataPeople">
                <!--people Card start-->
                <div class="table-responsive bsc-card" style="height: 310px">
                  <table id="table-sparkline" class="table" style="font-size: 0.5rem; border-top: medium none">
                    <ng-container *ngTemplateOutlet="matricTableBody"></ng-container>
                    <tbody id="tbody-sparkline" class="example-list" cdkDropListGroup cdkDropList
                      [cdkDropListData]="peopleDisplayData" (cdkDropListDropped)="drop($event, 137)">
                      <tr id="metric-{{ metric?.id }}" title="click to drag and drop"
                        *ngFor="let metric of peopleDisplayData; index as i" cdkDrag
                        class="example-box scorecard-metric"
                        (click)="enableDragClick(i, 137)" [cdkDragDisabled]="
                          dragPeopleEnableFlag[i]
                            ? dragPeopleEnableFlag[i]
                            : true
                        ">
                        <td (click)="
                            clickOverView(
                              137,
                              metric,
                              peopleDisplayData,
                              'People'
                            )
                          " class="text-primary cursor-pointer" style="width: 37%">
                          <span class="fw-bold text-underline" matTooltip="{{ metric.desc }}"
                            matTooltipClass="example-tooltip">{{ metric.name }}&nbsp;
                            <span *ngIf="metric?.unit_name">({{ metric?.unit_name }})</span></span>
                        </td>
                        <td [attr.colspan]="
                            ['req_aging', 'experience_profile'].includes(
                              metric.metric_name
                            )
                              ? '2'
                              : ''
                          ">
                          <div *ngIf="hasTrend(metric?.balanceTrend)" [chart]="metric?.balanceTrend"></div>
                          <div *ngIf="!hasTrend(metric?.balanceTrend)" class="no-data">
                            {{ commonText.no_trend_to_display }}
                          </div>
                        </td>
                        <td *ngIf="metric.actual_value != 'false'">
                          <span class="fw-bold" *ngIf="
                              !['req_aging', 'experience_profile'].includes(
                                metric.metric_name
                              )
                            " [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">{{ getFormattedValue(metric?.actual_value) }}</span>
                        </td>
                        <td class="text-center" *ngIf="metric.change != 'false'">
                          <div class="fw-bold" [ngClass]="{
                              spanRed: metric?.status === 'red',
                              spanGreen: metric?.status === 'green',
                              spanNeutral: metric?.status === 'gray',
                              spanAmber: metric?.status === 'amber'
                            }">
                            {{ getFormattedValue(metric?.change) }}
                          </div>
                          <span class="px-2 d-block">{{
                            metric.variance_per | appFormat : "float"
                            }}%</span>
                        </td>
                        <ng-container *ngTemplateOutlet="
                            actionCell;
                            context: { metric: metric }
                          "></ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--people Card end-->
              </div>
              <div class="row" *ngIf="noDataPeople">
                <div class="col-md-8 mx-auto mt-5" style="height: 200px">
                  <p class="text-center text-muted mt-2 fw-bold mb-1">
                    {{ commonText.no_records_found }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Performance Widgets" *ngIf="pageType !== 'vendorLevel'">
      <app-loading *ngIf="!widgetsLoaded"></app-loading>
      <div *ngIf="widgetsLoaded" class="mt-2">
        <div class="d-flex justify-content-between">
          <div *ngIf="isCreateWidget || isWidgetInfo" class="d-flex align-items-center go-back-btn" role="button"
            matTooltip="Go back" matTooltipPosition="above" (click)="navigateBack()">
            <mat-icon>keyboard_backspace</mat-icon>
          </div>
          <mat-slide-toggle *ngIf="!isCreateWidget && !isWidgetInfo && projectId" class="pe-3"
            (click)="toggleRecommendedWidgets()" [checked]="showRecommendedWidgets">Show Recommended
            Widgets</mat-slide-toggle>
          <div *appHasAccess="{ roles: ['!vendor'] }" class="ms-auto">
            <button *ngIf="
                !isCreateWidget && !isWidgetInfo && !showRecommendedWidgets
              " mat-flat-button mat-button color="primary" class="bg-primary text-white ms-auto" (click)="addWidget()">
              <mat-icon>add</mat-icon> Widget
            </button>
          </div>
        </div>
        <div *ngIf="!isCreateWidget && !isWidgetInfo" class="flex-container-1">
          <div *ngIf="!widgetsList.length" class="trn-no text-center w-100 mt-4">
            {{ commonText.no_records_found }}
          </div>
          <div class="flex-item p-1" *ngFor="let x of widgetsList">
            <div class="trn-x" [ngStyle]="{ background: x.color }" style="height: 200px"
              (click)="showRecommendedWidgets ? editWidget(x) : openWidget(x)">
              <div class="d-flex flex-row justify-content-end align-items-center gap-2" *ngIf="!showRecommendedWidgets">
                <a *appHasAccess="{ roles: ['!vendor'] }" class="add-btton" style="justify-content: center"
                  (click)="editWidget(x); $event.stopPropagation()">
                  <mat-icon aria-hidden="false" matTooltip="Edit" [matTooltipPosition]="'above'"
                    aria-label="material-icons-filled" class="cursor-pointer fs-6 w-75">edit</mat-icon>
                </a>
                <a *appHasAccess="{ roles: ['!vendor'] }" class="add-btton" style="justify-content: center"
                  (click)="showDeleteConfirmation(x); $event.stopPropagation()">
                  <mat-icon matTooltip="Delete" [matTooltipPosition]="'above'" aria-label="material-icons-filled"
                    style="font-size: 15px; color: red">delete</mat-icon>
                </a>
              </div>
              <h6 [matTooltip]="x.name" class="mb-0 trn-nm">
                {{ x.name }}
              </h6>
              <div class="trn-ph ellipsis">{{ x.description }}</div>
              <div class="mb-0 mt-2 trn-ph" *ngIf="x.created_by">
                <div class="d-flex align-items-center">
                  <mat-icon class="small-icon me-1">perm_identity</mat-icon>
                  <span>Created by</span>
                </div>
                <span style="display: flex; font-weight: 700">
                  {{ x.created_by.first_name + " " + x.created_by.last_name }}
                </span>
              </div>
              <p class="mb-0 mt-2 trn-ph" *ngIf="x.created_on">
                Created On
                <span style="display: flex; font-weight: 700">
                  {{ x.created_on | appFormat : "date" }}
                </span>
              </p>
              <p class="mb-0 mt-2 trn-ph" *ngIf="showRecommendedWidgets">
                {{displayLabels?.project | titlecase}}
                <span style="display: block; font-weight: 700" class="ellipsis" [matTooltip]="x.project.project_name">
                  {{ x.project.project_name }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="widget-create-container" *ngIf="isCreateWidget && !isWidgetInfo">
          <h5 *ngIf="!showRecommendedWidgets">
            {{ isWidgetEditMode ? "Update Widget" : "Create Widget" }}
          </h5>
          <form [formGroup]="widgetCreateForm">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Name</mat-label>
              <input matInput formControlName="name" />
            </mat-form-field>
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput formControlName="description" rows="3"></textarea>
            </mat-form-field>
          </form>
          <div class="d-flex justify-content-end">
            <button mat-flat-button mat-button color="primary" class="bg-primary text-white ms-auto"
              [disabled]="showRecommendedWidgets" (click)="showAddMetricDialog()">
              <mat-icon>add</mat-icon> Metric
            </button>
          </div>
          <div class="custom-height mt-2">
            <div class="table-container table-responsive" style="max-height: calc(100vh - 220px)">
              <table>
                <thead style="position: sticky; z-index: 1">
                  <tr>
                    <th *ngFor="let field of metricsTableColumns" scope="col">
                      {{ field }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of selectedMetrics">
                    <tr>
                      <td class="highlighted" [matTooltip]="item?.display_name">
                        {{ item?.display_name }}
                      </td>
                      <td class="highlighted">
                        <app-metrics-icon [unit_name]="item?.metric_unit_name"></app-metrics-icon>
                      </td>
                      <td>{{ item?.type }}</td>
                      <td>{{ item?.function?.display_name }}</td>
                      <td class="pt-1 pb-1" [ngClass]="{ 'disabled-icon': showRecommendedWidgets }">
                        <img (click)="removeMetric(item)" class="cursor-pointer"
                          src="./assets/images/comment-delete.svg" style="width: 16px" />
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tr *ngIf="!selectedMetrics?.length">
                  <td colspan="14" class="noRecords text-center mt-2">
                    <span class="mt-2">No metrics added </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button *ngIf="!showRecommendedWidgets" mat-flat-button mat-button color="primary"
              class="bg-primary text-white ms-auto mt-2" (click)="isWidgetEditMode ? updateWidget() : createWidget()">
              Save
            </button>
            <button *ngIf="showRecommendedWidgets" mat-flat-button mat-button color="primary"
              class="bg-primary text-white ms-auto mt-2" (click)="cloneWidget()">
              Clone
            </button>
          </div>
        </div>
        <div *ngIf="isWidgetInfo">
          <div class="widget-info">
            <p class="fw-bold mb-0">Name</p>
            <p class="mb-0">{{ currentWidget.name }}</p>
            <p class="fw-bold mb-0">Description</p>
            <p class="mb-0">{{ currentWidget.description }}</p>
            <div class="d-flex align-items-center">
              <span class="pe-2">Trend</span>
              <mat-slide-toggle class="pe-3" (click)="toggleTrendAndPointInTime()" [checked]="!showTrendView">Point in
                Time</mat-slide-toggle>
            </div>
            <form [formGroup]="performanceWidgetFilterForm">
              <div class="row align-items-center mt-2 gap-1 widget-filters">
                <mat-form-field *ngIf="showTrendView" appearance="outline" class="col-2 px-1 ms-2">
                  <mat-label style="font-size: 12px">Frequency</mat-label>
                  <mat-select formControlName="frequency" class="w-100" style="font-size: 12px; margin-top: 3px">
                    <mat-option *ngFor="let opt of frequencyList" [value]="opt.value">
                      {{ opt.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="col-9 d-flex align-items-center gap-3">
                  <mat-form-field *ngIf="showTrendView" class="w-25" appearance="outline" style="font-size: 12px">
                    <mat-label style="font-size: 12px">Start Date</mat-label>
                    <input matInput [matDatepicker]="picker1" formControlName="startDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field *ngIf="showTrendView" class="w-25" appearance="outline" style="font-size: 12px">
                    <mat-label style="font-size: 12px">End Date</mat-label>
                    <input matInput [matDatepicker]="picker2" formControlName="endDate" />
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker #picker2></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </form>
            <span class="fw-medium">View Table</span>
            <mat-slide-toggle class="mx-2" color="primary" [checked]="showLineChart" (change)="toggleView($event)"
              labelPosition="after">
            </mat-slide-toggle>
            <span class="fw-medium">View Chart</span>
            <div *ngIf="showTrendView">
              <div *ngIf="!showLineChart" class="table-container table-responsive mt-2"
                style="max-height: calc(100vh - 220px)">
                <table>
                  <thead>
                    <tr>
                      <th>Metric</th>
                      <th>Unit</th>
                      <th *ngFor="
                          let field of trendTableColumns?.slice(2);
                          let colIndex = index
                        " class="text-nowrap">
                        {{
                        frequency && frequency == "monthly"
                        ? (field | date : "MMM yyyy")
                        : frequency == "daily"
                        ? (field | appFormat : "date")
                        : frequency == "weekly"
                        ? (field | date : "yyyy-w")
                        : ""
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="
                        let metric of widgetTrendData?.metrics;
                        let i = index
                      ">
                      <tr>
                        <td class="highlighted" [matTooltip]="metric?.display_name">
                          {{ metric.display_name }}
                        </td>
                        <td class="highlighted text-center">
                          <app-metrics-icon [unit_name]="metric?.metric_unit_name"></app-metrics-icon>
                        </td>
                        <td *ngFor="
                            let col of metric.metric_data;
                            let last = last
                          ">
                          <span>
                            <ng-container *ngIf="
                                metric.metric_unit_name === '$';
                                else normalValue
                              ">
                              {{
                              col.value
                              ? (col.value | appFormat : "float")
                              : "–"
                              }}
                            </ng-container>
                            <ng-template #normalValue>
                              {{
                              col.value
                              ? (col.value | appFormat : "float")
                              : "–"
                              }}
                            </ng-template>
                          </span>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                  <tr *ngIf="!widgetTrendData?.metrics?.length">
                    <td colspan="14" class="noRecords text-center mt-2">
                      <span class="mt-2">{{
                        staticText.no_records_found
                        }}</span>
                    </td>
                  </tr>
                </table>
              </div>
              <highcharts-chart *ngIf="showLineChart && trendChartOptions" [Highcharts]="Highcharts"
                [options]="trendChartOptions" style="width: 100%; height: 200px; display: block"></highcharts-chart>
            </div>
            <div *ngIf="!showTrendView">
              <div>
                <div class="table-container mt-2" style="
                    max-height: calc(100vh - 220px);
                    width: 100%;
                    overflow-x: unset;
                  " *ngIf="!showLineChart">
                  <table style="width: 100%">
                    <thead>
                      <tr>
                        <th>Metric</th>
                        <th>Unit</th>
                        <th *ngFor="
                            let field of potTableColumns.slice(1);
                            let colIndex = index
                          " [ngClass]="{
                            'metrics-table-last-header':
                              colIndex === potTableColumns.slice(1).length - 1
                          }">
                          {{ field }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="
                          let metric of widgetTrendData?.metrics;
                          let i = index
                        ">
                        <tr>
                          <td class="highlighted" [matTooltip]="metric.display_name">
                            {{ metric.display_name }}
                          </td>
                          <td class="highlighted">
                            <app-metrics-icon [unit_name]="metric?.metric_unit_name"></app-metrics-icon>
                          </td>
                          <td *ngFor="let col of metric.metric_data">
                            <span [ngClass]="{
                                'missing-data': !col.value,
                                'table-missing-data': !col.value
                              }">
                              <ng-container *ngIf="
                                  metric.metric_unit_name === '$';
                                  else normalValue
                                ">
                                {{
                                col.value
                                ? (col.value | appFormat : "float")
                                : "–"
                                }}
                              </ng-container>
                              <ng-template #normalValue>
                                {{
                                col.value
                                ? (col.value | appFormat : "float")
                                : "–"
                                }}
                              </ng-template>
                            </span>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                    <tr *ngIf="!widgetTrendData?.metrics?.length">
                      <td colspan="14" class="noRecords text-center mt-2 table-no-records">
                        <span class="mt-2">{{
                          staticText.no_records_found
                          }}</span>
                      </td>
                    </tr>
                  </table>
                </div>
                <div *ngIf="showLineChart" class="ms-2 me-2">
                  <div class="row">
                    <div *ngFor="let chartOptions of pointInTimeChartOptions" class="col-12 col-sm-6 col-md-6 mb-1">
                      <highcharts-chart class="border border-secondary rounded" [Highcharts]="Highcharts"
                        [options]="chartOptions" style="width: 100%; height: 250px; display: block">
                      </highcharts-chart>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Pulse" *ngIf="pageType !== 'vendorLevel'">
      <app-loading *ngIf="!pulseInfoLoaded"></app-loading>
      <div *ngIf="pulseInfoLoaded" class="mt-2">
        <div class="d-flex justify-content-end gap-3" style="margin-bottom: 0.3rem;">
          <mat-slide-toggle class="pe-3" style="margin-top: 0.35rem;" (change)="togglePulseView($event)"
            [checked]="isPulseTableView">View as Table</mat-slide-toggle>
          <button mat-button (click)="showCreatePulseDialog()" class="bg-primary text-white">
            <mat-icon class="cursor-pointer fs-5">add
            </mat-icon>
            Pulse
          </button>
        </div>
        <div *ngIf="isPulseTableView">
          <div class="custom-height">
            <div class="table-container table-responsive" style="max-height: calc(100vh - 220px)">
              <table>
                <thead style="position: sticky; z-index: 1">
                  <tr>
                    <th *ngFor="let field of pulseTableColumns" scope="col" [attr.style]="
                        field === 'Raised by'
                          ? 'text-align:center'
                          : field === 'Action'
                          ? 'text-align:center'
                          : field === 'OU/GDP'
                          ? 'text-align:center'
                          : field === 'Project'
                          ? 'text-align:center'
                          : null
                      " [attr.width]="
                        field === 'Project'
                          ? '17%'
                          : field === 'OU/GDP'
                          ? '5%'
                          : field === 'Raised by'
                          ? '8%'
                          : field === 'Action'
                          ? '5%'
                          : null
                      ">
                      {{ field }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let item of pulsesInfo?.records; let i = index">
                    <tr [ngClass]="
                        !item.vendor || !item.project ? 'highlighted' : ''
                      ">
                      <td class="highlighted">{{ startValue + i + 1 }}</td>
                      <td class="highlighted" [matTooltip]="item?.title">
                        <div class="wrap-two-lines">{{ item?.title }}</div>
                      </td>
                      <td [matTooltip]="item?.description">
                        <span *ngIf="
                            item?.description && item?.description.length > 30
                          ">{{ item?.description | slice : 0 : 30 }}...</span>
                        <span *ngIf="
                            !item?.description || item?.description.length <= 30
                          ">
                          {{ item?.description }}
                        </span>
                      </td>
                      <td [matTooltip]="item?.project?.project_name" style="text-align: center">
                        <div class="wrap-two-lines">
                          {{ item?.project?.project_name || "-" }}
                        </div>
                      </td>
                      <td [matTooltip]="item?.vendor?.name" style="text-align: center">
                        {{ item?.vendor?.name || "-" }}
                      </td>
                      <td matTooltip="{{
                          item?.created_by?.first_name +
                            ' ' +
                            item?.created_by?.last_name
                        }}" style="text-align: center">
                        <!-- <div class="d-flex align-items-center text-truncate" > -->
                        <ng-container *ngIf="item?.created_by; else noUser">
                          <img src="./assets/Icons/user.svg" alt="user"
                            style="width: 16px; height: 16px; margin-right: 4px" />
                          <span style="white-space: nowrap">{{
                            item?.created_by?.first_name +
                            " " +
                            item?.created_by?.last_name || "-"
                            }}</span>
                        </ng-container>
                        <ng-template #noUser>-</ng-template>
                        <!-- </div> -->
                      </td>
                      <td class="text-center pt-1 pb-1 fs-13">
                        <div class="d-flex justify-content-center">
                          <div class="align-items-center">
                            <img class="cursor-pointer" src="./assets/images/pages/workforce/edit.svg" alt="edit"
                              (click)="showEditPulseDialog(item)" />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
                <tr *ngIf="!pulsesInfo?.count">
                  <td colspan="14" class="noRecords text-center mt-2">
                    <span class="mt-2">{{ commonText.no_records_found }} </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="d-flex align-items-center font-13" *ngIf="pulsesInfo?.count > 0">
            <div class="p-1">
              <div class="d-flex flex-row align-items-center text-dark">
                <span class="p-1">Displaying</span>
                <span class="p-1" style="margin-bottom: 0 !important">
                  {{ startValue + 1 }}-{{
                  endValue > pulsesInfo.count ? pulsesInfo.count : endValue
                  }}
                </span>

                <span class="p-1">of {{ pulsesInfo?.count | appFormat : "number" }}</span>
                <span class="p-1">records</span>
              </div>
            </div>
            <div class="p=1">
              <select class="form-select form-select-sm table-sort-filter" aria-label="Default select example"
                [(ngModel)]="sortRecords" (ngModelChange)="getRecords()">
                <option *ngFor="let option of sortOptions" [value]="option">
                  {{ option }}
                </option>
              </select>
            </div>
            <div class="p-1 ms-auto">
              <ngb-pagination [pageSize]="sortRecords" [collectionSize]="pulsesInfo?.count" [maxSize]="2"
                [rotate]="true" [(page)]="CurrentPage" [boundaryLinks]="true" (pageChange)="getRecords()">
              </ngb-pagination>
            </div>
          </div>
        </div>
        <div *ngIf="!isPulseTableView">
          <app-pulse [pulsesList]="pulsesInfo" (pulseRefresh)="filterPulsesInfoList($event)"></app-pulse>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Additional Information" *ngIf="pageType !== 'vendorLevel'">
      <app-loading *ngIf="!additionalInfoLoaded"></app-loading>
      <div *ngIf="additionalInfoLoaded" class="mt-2">
        <div class="accordion" id="accordionExample">
          <div class="accordion-item">
            <h2 class="accordion-header" id="assessmentHeading">
              <button #assessmentAccordionBtn class="accordion-button"
                [class.collapsed]="activeAccordion !== 'assessment'" type="button" data-bs-toggle="collapse"
                data-bs-target="#assessmentCollapse" aria-expanded="{{ activeAccordion === 'assessment' }}"
                aria-controls="assessmentCollapse" style="font-size: 13px" (click)="openAccordion('assessment')">
                {{
                "Assessments (" +
                (assessmentsList.length | appFormat : "number") +
                ")"
                }}
              </button>
            </h2>
            <div #assessmentAccordion id="assessmentCollapse" class="accordion-collapse collapse"
              [class.show]="activeAccordion === 'assessment'" aria-labelledby="assessmentHeading"
              data-bs-parent="#accordionExample">
              <div class="accordion-body p-2">
                <div>
                  <mat-form-field appearance="outline" *ngIf="activeAccordion === 'assessment'">
                    <mat-label>Assessment</mat-label>
                    <mat-select [(ngModel)]="currentAssessment" (ngModelChange)="onAssessmentChange()">
                      <ng-container *ngFor="let item of assessmentsList">
                        <mat-option [value]="item.id">
                          {{ item.name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="custom-height">
                        <div class="table-container table-responsive" style="max-height: calc(100vh - 220px)">
                          <table class="table table-bordered">
                            <thead style="position: sticky; z-index: 1">
                              <tr>
                                <th *ngFor="let field of tableColumns" scope="col">
                                  {{ field }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="
                                  let group of assessmentAggregateData;
                                  let groupIndex = index
                                ">
                                <tr *ngFor="
                                    let question of group.questions;
                                    let i = index
                                  ">
                                  <td *ngIf="i === 0" class="highlighted" [attr.rowspan]="group.questions.length">
                                    <span [matTooltip]="group.group_name">{{ groupIndex + 1 }}.
                                      {{ group.group_name }}</span>
                                  </td>
                                  <td class="highlighted" [matTooltip]="question.question">
                                    {{ i + 1 }}. {{ question.question }}
                                  </td>
                                  <td class="text-center" style="min-width: 250px">
                                    <highcharts-chart style="display: flex" [Highcharts]="Highcharts"
                                      [options]="question.chart" [callbackFunction]="chartCallback" [oneToOne]="true"
                                      style="
                                        display: block;
                                        width: 300px;
                                        height: 180px;
                                      "></highcharts-chart>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                            <tr *ngIf="!assessmentAggregateData?.length">
                              <td colspan="10" class="noRecords text-center mt-2">
                                <span class="mt-2">{{ commonText.no_records_found }}
                                </span>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="auditHeading">
              <button #auditsAccordionBtn class="accordion-button" [class.collapsed]="activeAccordion !== 'audit'"
                type="button" data-bs-toggle="collapse" data-bs-target="#auditCollapse"
                aria-expanded="{{ activeAccordion === 'audit' }}" aria-controls="auditCollapse" style="font-size: 13px"
                (click)="openAccordion('audit')">
                {{
                "Audits (" + (auditsList.length | appFormat : "number") + ")"
                }}
              </button>
            </h2>
            <div #auditsAccordion id="auditCollapse" class="accordion-collapse collapse"
              [class.show]="activeAccordion === 'audit'" aria-labelledby="auditHeading"
              data-bs-parent="#accordionExample">
              <div class="accordion-body p-2">
                <div class="mt-2">
                  <mat-form-field appearance="outline" *ngIf="activeAccordion === 'audit'">
                    <mat-label>Audit</mat-label>
                    <mat-select [(ngModel)]="currentAudit" (ngModelChange)="onAuditChange()">
                      <mat-option value="">All</mat-option>
                      <ng-container *ngFor="let item of auditsList">
                        <mat-option [value]="item.id">
                          {{ item.name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                  <div class="table-container table-responsive" style="max-height: calc(100vh - 220px)">
                    <table>
                      <thead style="position: sticky; z-index: 1">
                        <tr>
                          <th *ngFor="let field of auditTableColumns" scope="col">
                            {{ field }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let response of auditInstanceInfo;
                            let i = index
                          ">
                          <td class="highlighted">{{ i + 1 }}</td>
                          <td class="highlighted" [matTooltip]="response.template_title">
                            {{ response.template_title }}
                          </td>
                          <td class="text-nowrap" [matTooltip]="getAuditorsTooltip(response.auditors)">
                            <ng-container *ngIf="response.auditors && response.auditors.length > 0; else noAuditor">
                              <div class="d-inline-flex align-items-center">
                                <img
                                  src="./assets/Icons/user.svg"
                                  alt="user"
                                  style="width: 16px; height: 16px; margin-right: 4px;"
                                />
                                <span>
                                  {{ (response.auditors[0].first_name || '') + ' ' + (response.auditors[0].last_name || '') | titlecase }}
                                </span>
                                <span
                                  *ngIf="response.auditors.length > 1"
                                  class="badge badge-light border ml-1 px-1"
                                  style="font-size: 11px; margin-left: 4px;"
                                >
                                  +{{ response.auditors.length - 1 }}
                                </span>
                              </div>
                            </ng-container>
                            <ng-template #noAuditor>-</ng-template>
                          </td>
                          <td>
                            {{
                            response.observation_count | appFormat : "number"
                            }}
                          </td>
                          <td class="text-center" style="min-width: 300px; max-width: 300px">
                            <highcharts-chart [Highcharts]="Highcharts" [options]="response.chart"
                              [callbackFunction]="chartCallback" [oneToOne]="true" style="
                                display: block;
                                width: 300px;
                                height: 180px;
                              "></highcharts-chart>
                          </td>
                        </tr>
                      </tbody>
                      <tr *ngIf="!auditInstanceInfo?.length">
                        <td colspan="10" class="noRecords text-center mt-2" style="padding: 0.75rem 0px !important">
                          <span class="mt-2">{{ commonText.no_records_found }}
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="accordion-item">
            <h2 class="accordion-header" id="govHeading">
              <button #govAccordionBtn class="accordion-button" [class.collapsed]="activeAccordion !== 'gov'"
                type="button" data-bs-toggle="collapse" data-bs-target="#govCollapse"
                aria-expanded="{{ activeAccordion === 'gov' }}" aria-controls="govCollapse" style="font-size: 13px"
                (click)="openAccordion('gov')">
                {{
                "Governance Lighthouse (" +
                (govAssessmentsList.length | appFormat : "number") +
                ")"
                }}
              </button>
            </h2>
            <div #govAccordion id="govCollapse" class="accordion-collapse collapse"
              [class.show]="activeAccordion === 'gov'" aria-labelledby="govHeading" data-bs-parent="#accordionExample">
              <div class="accordion-body p-1">
                <div class="mt-2">
                  <mat-form-field appearance="outline" *ngIf="activeAccordion === 'gov'">
                    <mat-label>Governance Assessment</mat-label>
                    <mat-select [(ngModel)]="currentGovAssessment" (ngModelChange)="onGovAssessmentChange()">
                      <ng-container *ngFor="let item of govAssessmentsList">
                        <mat-option [value]="item.id">
                          {{ item.name }}
                        </mat-option>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="custom-height">
                        <div class="table-container table-responsive" style="max-height: calc(100vh - 220px)">
                          <table class="table table-bordered">
                            <thead style="position: sticky; z-index: 1">
                              <tr>
                                <th *ngFor="let field of tableColumns" scope="col">
                                  {{ field }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <ng-container *ngFor="
                                  let group of govAggregateData;
                                  let groupIndex = index
                                ">
                                <tr *ngFor="
                                    let question of group.questions;
                                    let i = index
                                  ">
                                  <td *ngIf="i === 0" class="highlighted" [matTooltip]="group.group_name"
                                    matTooltipPosition="below" [attr.rowspan]="group.questions.length">
                                    {{ groupIndex + 1 }}. {{ group.group_name }}
                                  </td>
                                  <td [matTooltip]="question.question" class="highlighted">
                                    {{ i + 1 }}. {{ question.question }}
                                  </td>
                                  <td class="text-center" style="min-width: 250px">
                                    <highcharts-chart style="display: flex" [Highcharts]="Highcharts"
                                      [options]="question.chart" [callbackFunction]="chartCallback" [oneToOne]="true"
                                      style="
                                        display: block;
                                        width: 300px;
                                        height: 180px;
                                      "></highcharts-chart>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                            <tr *ngIf="!govAggregateData?.length">
                              <td colspan="10" class="noRecords text-center mt-2">
                                <span class="mt-2">{{ commonText.no_records_found }}
                                </span>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <div *ngIf="matrixOverView" class="scorecard d-block mt-2">
    <div class="d-flex align-items-center go-back-btn" role="button" matTooltip="Go back" matTooltipPosition="above"
      (click)="closeMatrixOverview()">
      <mat-icon>keyboard_backspace</mat-icon>
    </div>
    <div class="p-0 d-flex mb-4 align-items-center gap-2">
      <h5 class="m-0">
        {{ cardMatric?.name }}
        <span *ngIf="cardMatric?.unit_name">({{ cardMatric?.unit_name }})</span>
        :
      </h5>
      <span class="mt-1">{{ cardMatric?.desc }}</span>
    </div>
    <div class="row gap-4 ms-1">
      <div class="p-4 pt-1 pb-0 text-center col-2 value" style="background-color: rgb(237, 231, 225)" *ngIf="
          cardMatric?.actual_value != 'false' &&
          cardMatric?.metric_name !== 'req_aging' &&
          cardMatric?.metric_name !== 'experience_profile'
        ">
        <span style="font-size: 12px">Current Value</span>
        <div class="mt-2 value-box" [matTooltip]="
            (cardMatric?.actual_value ? cardMatric?.actual_value : 0)
              | appFormat : 'float'
          ">
          <span class="fw-bold" [ngClass]="{
              spanRed: cardMatric?.status === 'red',
              spanGreen: cardMatric?.status === 'green',
              spanNeutral: cardMatric?.status === 'gray',
              spanAmber: cardMatric?.status === 'amber'
            }">{{
            (cardMatric?.actual_value ? cardMatric?.actual_value : 0)
            | appFormat : "float"
            }}</span>
        </div>
      </div>
      <div class="p-4 pt-1 pb-0 text-center col-2 value" style="background-color: rgb(237, 231, 225)" *ngIf="
          cardMatric?.change != 'false' &&
          cardMatric?.metric_name !== 'req_aging' &&
          cardMatric?.metric_name !== 'experience_profile'
        ">
        <span style="font-size: 12px">% Change</span><br />
        <div class="fw-bold value-box" [ngClass]="{
            spanRed: cardMatric?.status === 'red',
            spanGreen: cardMatric?.status === 'green',
            spanNeutral: cardMatric?.status === 'gray',
            spanAmber: cardMatric?.status === 'amber'
          }" [matTooltip]="
            (cardMatric?.change ? cardMatric?.change : 0) | appFormat : 'float'
          ">
          {{
          (cardMatric?.change ? cardMatric?.change : 0) | appFormat : "float"
          }}
        </div>
        <span class="px-2 d-block">{{ cardMatric?.variance_per | appFormat : "float" }}%</span>
      </div>
      <div class="trendchart col-7">
        <div *ngIf="hasTrend(cardMatric?.overviewTrend)" [chart]="cardMatric?.overviewTrend"></div>
        <div *ngIf="!hasTrend(cardMatric?.overviewTrend)" class="no-data">
          {{ commonText.no_trend_to_display }}
        </div>
      </div>
    </div>
    <mat-tab-group mat-align-tabs="start" class="head" mat-stretch-tabs [selectedIndex]="0">
      <mat-tab *ngIf="cardMatric?.zohoreport?.length && isAnalyticsEnabled">
        <ng-template mat-tab-label>
          <div class="tab-label">
            <img src="./assets/images/balancescore/metric_indicators/insights.png" width="24px" height="24px"
              class="me-2" alt="insights" class="tab-icon" />
            Insights
          </div>
        </ng-template>
        <div *ngIf="cardMatric?.zohoreport?.length > 0">
          <app-zoho-dashboard *ngIf="isValidUrl(cardMatric?.zohoURL)" [reportUrl]="cardMatric?.zohoURL"
            [title]="'scorecard metric'"></app-zoho-dashboard>
          <div *ngIf="!isValidUrl(cardMatric?.zohoURL)" class="d-flex justify-content-center mt-4">
            Kindly refresh the page to view the report
          </div>
        </div>
        <div *ngIf="cardMatric?.zohoreport?.length == 0" class="text-center p-4">
          <span>No reports found</span>
        </div>
      </mat-tab>
      <mat-tab label="Linked Metrics">
        <ng-template mat-tab-label>
          <div class="tab-label">
            <img src="./assets/images/balancescore/metric_indicators/linkedmetrics.png" width="24px" height="24px"
              class="me-2" alt="linkedMatrics" class="tab-icon" />
            Linked Metrics
          </div>
        </ng-template>
        <div>
          <br />
          <div class="row" style="width: 98%; margin-left: 10px">
            <div class="col-md-12 mb-4">
              <div class="column-bg-1 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center justify-content-center ms-2 w-100">
                  <img src="./assets/images/balancescore/metric_indicators/linkedmetrics.png" width="24px" height="24px"
                    class="me-2" alt="linkedMatrics" />
                  <span class="title">Linked Metrics</span>
                  <button class="small-icon-button ms-auto mb-3" style="box-shadow: 0px 0px 15px gray"
                    matTooltip="Check impact of linked metrics & explore AI-powered what-if reasoning" mat-icon-button>
                    <img class="mb-1" src="assets/Icons/whatIfIcon.svg" alt="what if" height="30px" width="30px"
                      (click)="openWhatIfModel()" />
                  </button>
                </div>
              </div>
              <!--Customer Card start-->
              <div class="table-responsive">
                <table id="table-sparkline" class="table" style="
                    font-size: 0.5rem;
                    border-top: medium none;
                    min-height: 60px;
                  ">
                  <thead>
                    <tr>
                      <th class="tblBg">Metrics</th>
                      <th class="tblBg">
                        {{ balanceScorecardText?.dashboard?.trend }}
                      </th>
                      <th class="tblBg">
                        Current Value
                        <span *ngIf="cardMatric?.unit_name"></span>
                      </th>
                      <th class="tblBg">Change</th>
                    </tr>
                  </thead>
                  <tbody id="tbody-sparkline" class="example-list">
                    <tr *ngFor="let item of linkedMatrics; let i = index" class="example-box">
                      <td>
                        <span class="fw-bold text-center" atTooltipClass="example-tooltip">{{ item?.display_name }} ({{
                          item?.unit_name
                          }})</span>
                      </td>
                      <td class="text-center">
                        <div class="d-flex justify-content-center" [chart]="item?.trend"></div>
                      </td>
                      <td class="text-center">
                        <span class="fw-bold" [ngClass]="{
                            spanRed: item?.status === 'red',
                            spanGreen: item?.status === 'green',
                            spanNeutral: item?.status === 'gray',
                            spanAmber: item?.status === 'amber'
                          }">{{
                          formatNumber(
                          item?.actual_value[item?.actual_value.length - 1]
                          ?.actual_value
                          ? item?.actual_value[
                          item?.actual_value.length - 1
                          ]?.actual_value
                          : 0,
                          2
                          ) | appFormat : "float"
                          }}</span>
                      </td>
                      <td class="text-center">
                        <div class="fw-bold" [ngClass]="{
                            spanRed: item?.status === 'red',
                            spanGreen: item?.status === 'green',
                            spanNeutral: item?.status === 'gray',
                            spanAmber: item?.status === 'amber'
                          }">
                          {{ formatNumber(item?.change) | appFormat : "float" }}
                        </div>
                        <span class="px-2 d-block">{{
                          item.percent_change | appFormat : "float"
                          }}%</span>
                      </td>
                    </tr>
                    <tr *ngIf="linkedMatrics?.length == 0">
                      <td colspan="4">
                        <p class="text-center mt-2 mb-1 fs-16">
                          No Linked Metrics Configured
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Performance BenchMark">
        <ng-template mat-tab-label>
          <div class="tab-label">
            <img src="./assets/images/balancescore/metric_indicators/perforamanceBench.png" width="24px" height="24px"
              class="me-2" alt="performanceBenchMark" class="tab-icon" />
            Performance Benchmark
          </div>
        </ng-template>

        <div class="row mt-4" style="width: 98%; margin-left: 10px">
          <div class="col-md-12 mb-4">
            <div class="column-2-bg d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center justify-content-center ms-2">
                <img src="./assets/images/balancescore/metric_indicators/perforamanceBench.png" width="24px"
                  height="24px" class="me-2" alt="performanceBenchMark" />
                <span class="title">Performance Benchmark</span>
              </div>
            </div>
            <!--Customer Card start-->
            <div class="table-responsive">
              <table id="table-sparkline" class="table" style="
                  font-size: 0.5rem;
                  border-top: medium none;
                  min-height: 60px;
                ">
                <thead>
                  <tr>
                    <th class="tblBg" [matTooltip]="
                        projectId ? (displayLabels?.project | titlecase) + 's' + ' with similar tags' : ''
                      ">
                      {{ getBenchmarkTableHeader() }}
                    </th>
                    <th class="tblBg">
                      {{ balanceScorecardText?.dashboard?.trend }}
                    </th>
                    <th class="tblBg">
                      Current Value
                      <span *ngIf="cardMatric?.unit_name"></span>
                    </th>
                    <th class="tblBg" matTooltip="Change from previous period" matTooltipPosition="above">
                      Change
                    </th>
                    <th class="tblBg" matTooltip="Variance between the selected entity against the overall"
                      matTooltipPosition="above">
                      Variance
                    </th>
                    <th class="tblBg">% of Variance</th>
                  </tr>
                </thead>
                <tbody id="tbody-sparkline" class="example-list">
                  <tr *ngFor="let item of performanceBenchMark; let i = index" class="example-box">
                    <td>
                      <span class="fw-bold" matTooltipClass="example-tooltip">{{
                        item?.name
                        }}</span>
                    </td>
                    <td>
                      <div [chart]="item?.trend" class="d-flex justify-content-center"></div>
                    </td>
                    <td class="text-center">
                      <span class="fw-bold" [ngClass]="{
                          spanRed: item?.status === 'red',
                          spanGreen: item?.status === 'green',
                          spanNeutral: item?.status === 'gray',
                          spanAmber: item?.status === 'amber'
                        }">{{
                        formatNumber(
                        item?.actual_value[item?.actual_value.length - 1]
                        ?.actual_value
                        ? item?.actual_value[item?.actual_value.length - 1]
                        ?.actual_value
                        : 0,
                        2
                        ) | appFormat : "float"
                        }}</span>
                    </td>
                    <td class="text-center">
                      <div class="fw-bold text-center" [ngClass]="{
                          spanRed: item?.status === 'red',
                          spanGreen: item?.status === 'green',
                          spanNeutral: item?.status === 'gray',
                          spanAmber: item?.status === 'amber'
                        }">
                        {{ formatNumber(item?.change) | appFormat : "float" }}
                      </div>
                      <span class="px-2 d-block">{{ item.percent_change | appFormat : "float" }}%</span>
                    </td>
                    <td class="text-center">
                      <div class="fw-bold">
                        <span class="spanvalue">
                          {{
                          formatNumber(
                          getDifference(
                          item?.actual_value[
                          item?.actual_value?.length - 1
                          ]?.actual_value,
                          cardMatric?.actual_value
                          )
                          ) | appFormat : "float"
                          }}
                        </span>
                      </div>
                    </td>
                    <td class="fw-bold text-center">
                      {{
                      getContribution(item, cardMatric?.actual_value)
                      | appFormat : "float"
                      }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--Customer Card end-->
          </div>
          <div class="row" *ngIf="performanceBenchMark?.length == 0" d style="position: absolute; bottom: 30px">
            <div class="col-md- 4mx-auto">
              <p class="text-center mt-2 mb-1">
                {{ commonText.no_records_found }}
              </p>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #matricTableBody>
  <thead>
    <tr style="background: #1a85d6">
      <th class="tblBg">
        {{ balanceScorecardText?.dashboard?.metrics }}
      </th>
      <th class="tblBg">
        {{ balanceScorecardText?.dashboard?.trend }}
      </th>
      <th class="tblBg">Current Value</th>
      <th class="tblBg">
        {{ balanceScorecardText?.dashboard?.change }}
      </th>
      <th class="tblBg text-center" *ngIf="showActionColumn">Action</th>
    </tr>
  </thead>
</ng-template>

<!-- Status-colour counts beside a quadrant name; click one to filter that colour out. -->
<ng-template #statusCounts let-quadrantId="quadrantId">
  <span class="status-count-chips ms-2">
    <span *ngFor="let chip of statusChips" class="status-count-chip" [ngClass]="'status-count-chip--' + chip.key"
      [class.status-count-chip--off]="!isStatusSelected(quadrantId, chip.key)" [matTooltip]="
        (isStatusSelected(quadrantId, chip.key) ? 'Hide ' : 'Show ') +
        chip.label +
        ' metrics'
      " (click)="toggleStatusFilter(quadrantId, chip.key)">
      {{ getStatusCount(quadrantId, chip.key) }}
    </span>
  </span>
</ng-template>

<ng-template #actionCell let-metric="metric">
  <td class="text-center action-cell" *ngIf="showActionColumn">
    <button mat-icon-button *ngIf="canCreateMetricAction(metric)" matTooltip="Create action"
      (click)="$event.stopPropagation(); createMetricAction(metric)">
      <mat-icon>add</mat-icon>
    </button>
    <button mat-icon-button *ngIf="hasOpenMetricAction(metric)" matTooltip="View Action"
      (click)="$event.stopPropagation(); viewMetricAction(metric)">
      <mat-icon>visibility</mat-icon>
    </button>
  </td>
</ng-template>

<ng-template #info>
  <div class="modal-dialog custom-width m-0">
    <div class="modal-content">
      <app-modal-header-common [title]="infoQuadrantName" [dialogRef]="quadrantDialog">
      </app-modal-header-common>

      <div class="modal-body" style="width: 55vw">
        <div class="row">
          <div class="col-md-12">
            <div class="custom-height infoQuadrant">
              <div class="table-container overflow-scroll" style="max-height: calc(100vh - 400px)">
                <table>
                  <thead style="position: sticky; z-index: 1">
                    <tr>
                      <th>Metrics</th>
                      <th>Description</th>
                      <th class="text-center">Unit</th>
                      <th class="text-center">HTB/LTB</th>
                      <th style="text-align: center">Target</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of quadrantInfoDetails; let i = index">
                      <td class="highlighted" [matTooltip]="item?.display_name">
                        <div class="wrap-two-lines">
                          {{ item?.display_name }}
                        </div>
                      </td>
                      <td [matTooltip]="item?.description">
                        <div class="wrap-two-lines">
                          {{ item?.description }}
                        </div>
                      </td>
                      <td class="text-center">
                        <app-metrics-icon [unit_name]="item?.unit_name"></app-metrics-icon>
                      </td>
                      <td [matTooltip]="getTooltipText(item?.mos_type_name)" matTooltipPosition="above"
                        class="text-center">
                        {{ item?.mos_type_name }}
                      </td>
                      <td style="text-align: center">
                        {{ item?.off_track_value | number }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="dialogClose()" [disabled]="disableFields" mat-button color="primary" class="mx-1">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>